"use client";
import Image from "next/image";
import Search from "../search/search";
import { useEffect, useState } from "react";
import { useAppContext } from "/context/app-context";

const platform = "your device";

export default function Hero({ classes }: { classes: string }) {
  const { device } = useAppContext();

  const [isMobileDevice, setIsMobileDevice] = useState(true);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsMobileDevice(device.isMobile);
    }
  }, [device]);

  return (
    <>
      <div
        className={`relative w-full mb-2 ${classes} py-4 bg-gradient-to-r from-getjar-darkorange to-getjar-orange`}
      >
        {!isMobileDevice && (
          <Image
            src="/heroBg.webp"
            placeholder="blur"
            blurDataURL="/heroBg-blur.webp"
            alt="Hero Background"
            fill
            priority
            quality={90}
            className="object-cover absolute top-0 left-0 w-full h-full "
          />
        )}

        <div className="md:container md:mx-auto flex flex-col sm:flex-row justify-between items-center sm:px-4 relative z-10">
          <div className="heroContent w-full text-center sm:text-left lg:max-w-[60%]">
            <h1 className="text-white uppercase pt-1 text-2xl lg:text-5xl pb-1">
              The world&apos;s biggest open app store for{" "}
              <span className="text-white">{platform}</span>
            </h1>
            <Search />
          </div>

          {!isMobileDevice && (
            <Image
              src="/hero-image.webp"
              alt="GetJar Hero"
              priority
              width={407}
              height={363}
              quality={100}
              className="w-auto h-auto max-w-[407px] max-h-[363px]"
            />
          )}
        </div>
      </div>
    </>
  );
}
